<template>
  <section class="pyramid module">
    <div class="container">
      <div class="pyramid-svg-wrapper">
        <svg
          class="pyramid-svg"
          width="100%"
          height="100%"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 997.84 757.05">
          <defs>
            <linearGradient
              id="linear-gradient"
              x1="839.62"
              y1="677.25"
              x2="839.62"
              y2="60.75"
              gradientTransform="translate(0 733.5) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#ffef00" />
              <stop
                offset=".48"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#1d78da" />
            </linearGradient>
            <clipPath id="clippath">
              <path
                d="M903.42,516.35l88.55,124.4c9.43,13.24-.04,31.6-16.29,31.6h-272.71c-11.05,0-20-8.95-20-20v-137c0-11.05,8.95-20,20-20h159.72c16.18,0,31.35,7.83,40.73,21Z"
                style="fill: none" />
            </clipPath>
            <radialGradient
              id="radial-gradient"
              cx="129.21"
              cy="764.88"
              fx="129.21"
              fy="764.88"
              r="1"
              gradientTransform="translate(-35219 -5530) rotate(90) scale(47 -47)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#00d9ea"
                stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="radial-gradient-2"
              cx="130.04"
              cy="764.08"
              fx="130.04"
              fy="764.08"
              r="1"
              gradientTransform="translate(-24484.5 -3748.5) rotate(90) scale(33 -33)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#00d9ea"
                stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="linear-gradient-2"
              x1="703.25"
              y1="190.25"
              x2="758.25"
              y2="190.25"
              gradientTransform="translate(0 733.5) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#1d78da" />
              <stop
                offset=".48"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#ffef00" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-3"
              x1="527.25"
              y1="668.25"
              x2="527.25"
              y2="60.25"
              gradientTransform="translate(0 733.5) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#ffef00" />
              <stop
                offset=".48"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#1d78da" />
            </linearGradient>
            <clipPath id="clippath-1">
              <rect
                x="393.25"
                y="496.25"
                width="268"
                height="177"
                rx="20"
                ry="20"
                style="fill: none" />
            </clipPath>
            <radialGradient
              id="radial-gradient-3"
              cx="129.21"
              cy="764.88"
              fx="129.21"
              fy="764.88"
              r="1"
              gradientTransform="translate(-35422 -5529) rotate(90) scale(47 -47)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#00d9ea"
                stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="radial-gradient-4"
              cx="130.04"
              cy="764.08"
              fx="130.04"
              fy="764.08"
              r="1"
              gradientTransform="translate(-24687.5 -3747.5) rotate(90) scale(33 -33)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#00d9ea"
                stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="linear-gradient-4"
              x1="500.25"
              y1="189.25"
              x2="555.25"
              y2="189.25"
              gradientTransform="translate(0 733.5) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#1d78da" />
              <stop
                offset=".48"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#ffef00" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-5"
              x1="214.38"
              y1="669.75"
              x2="214.38"
              y2="60.75"
              gradientTransform="translate(0 733.5) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#ffef00" />
              <stop
                offset=".48"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#1d78da" />
            </linearGradient>
            <clipPath id="clippath-2">
              <path
                d="M150.3,516.75l-88.55,124.4c-9.43,13.24,.04,31.6,16.29,31.6H350.75c11.05,0,20-8.95,20-20v-137c0-11.05-8.95-20-20-20H191.03c-16.18,0-31.35,7.83-40.73,21Z"
                style="fill: none" />
            </clipPath>
            <radialGradient
              id="radial-gradient-5"
              cx="129.21"
              cy="764.88"
              fx="129.21"
              fy="764.88"
              r="1"
              gradientTransform="translate(-35635 -5529) rotate(90) scale(47 -47)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#00d9ea"
                stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="radial-gradient-6"
              cx="130.04"
              cy="764.08"
              fx="130.04"
              fy="764.08"
              r="1"
              gradientTransform="translate(-24900.5 -3747.5) rotate(90) scale(33 -33)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#00d9ea"
                stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="linear-gradient-6"
              x1="287.25"
              y1="189.25"
              x2="342.25"
              y2="189.25"
              gradientTransform="translate(0 733.5) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#1d78da" />
              <stop
                offset=".48"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#ffef00" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-7"
              x1="527.25"
              y1="673.25"
              x2="527.25"
              y2="54.25"
              gradientTransform="translate(0 733.5) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#ffef00" />
              <stop
                offset=".48"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#1d78da" />
            </linearGradient>
            <clipPath id="clippath-3">
              <path
                d="M310.23,297.33c9.46-12.42,24.17-19.71,39.78-19.71h354.45c15.61,0,30.32,7.29,39.78,19.71l110.54,145.17c10.02,13.17,.64,32.12-15.91,32.12H215.6c-16.55,0-25.94-18.95-15.91-32.12l110.54-145.17Z"
                style="fill: none" />
            </clipPath>
            <radialGradient
              id="radial-gradient-7"
              cx="129.21"
              cy="764.88"
              fx="129.21"
              fy="764.88"
              r="1"
              gradientTransform="translate(-35424 -5748) rotate(90) scale(47 -47)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#00d9ea"
                stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="radial-gradient-8"
              cx="130.04"
              cy="764.08"
              fx="130.04"
              fy="764.08"
              r="1"
              gradientTransform="translate(-24689.5 -3966.5) rotate(90) scale(33 -33)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#00d9ea"
                stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="linear-gradient-8"
              x1="498.25"
              y1="408.25"
              x2="553.25"
              y2="408.25"
              gradientTransform="translate(0 733.5) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#1d78da" />
              <stop
                offset=".48"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#ffef00" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-9"
              x1="527.25"
              y1="674.75"
              x2="527.25"
              y2="55.25"
              gradientTransform="translate(0 733.5) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#ffef00" />
              <stop
                offset=".48"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#1d78da" />
            </linearGradient>
            <clipPath id="clippath-4">
              <path
                d="M477.09,76.45c9.5-11.53,23.65-18.2,38.59-18.2h22.17c14.94,0,29.09,6.68,38.59,18.2l120.37,146.08c10.75,13.05,1.47,32.72-15.43,32.72H372.16c-16.9,0-26.18-19.67-15.43-32.72l120.37-146.08Z"
                style="fill: none" />
            </clipPath>
            <radialGradient
              id="radial-gradient-9"
              cx="129.21"
              cy="764.88"
              fx="129.21"
              fy="764.88"
              r="1"
              gradientTransform="translate(-35424 -5962) rotate(90) scale(47 -47)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#00d9ea"
                stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="radial-gradient-10"
              cx="130.04"
              cy="764.08"
              fx="130.04"
              fy="764.08"
              r="1"
              gradientTransform="translate(-24689.5 -4180.5) rotate(90) scale(33 -33)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#00d9ea"
                stop-opacity="0" />
            </radialGradient>
            <linearGradient
              id="linear-gradient-10"
              x1="498.25"
              y1="622.25"
              x2="553.25"
              y2="622.25"
              gradientTransform="translate(0 733.5) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#1d78da" />
              <stop
                offset=".48"
                stop-color="#00d9ea" />
              <stop
                offset="1"
                stop-color="#ffef00" />
            </linearGradient>
          </defs>
          <g
            style="isolation: isolate"
            transform="translate(-30 0)">
            <g id="Bot-right">
              <path
                id="Color"
                d="M903.7,516.75l88.55,124.4c9.43,13.24-.04,31.6-16.29,31.6h-272.71c-11.05,0-20-8.95-20-20v-137c0-11.05,8.95-20,20-20h159.72c16.18,0,31.35,7.83,40.73,21Z"
                style="fill: url(#linear-gradient)"
                @mouseover="videoMouseEnter(4)"
                @mouseleave="videoMouseLeave()"
                @click="openModal(data, 4)" />
              <g
                id="BG"
                style="mix-blend-mode: screen">
                <g style="clip-path: url(#clippath)">
                  <foreignObject
                    v-if="!isSafari"
                    width="4080"
                    height="3072"
                    transform="translate(659.16 448) scale(.083)">
                    <video
                      ref="video4"
                      width="4080"
                      height="3072"
                      style="object-fit: cover"
                      muted
                      loop>
                      <source
                        :src="
                          data.items[4].mp4_file_thumb
                            ? data.items[4].mp4_file_thumb.url
                            : data.items[4].mp4_file.url
                        "
                        type="video/mp4" />

                      Your browser does not support the video tag.
                    </video>
                  </foreignObject>
                </g>
              </g>
              <g
                id="Button"
                data-name="Button">
                <circle
                  cx="730.25"
                  cy="542.75"
                  r="47"
                  style="fill: url(#radial-gradient); fill-opacity: 0.5" />
                <circle
                  cx="730.25"
                  cy="542.75"
                  r="46.5"
                  style="fill: none; stroke: rgba(186, 187, 187, 0.12)" />
                <circle
                  cx="730.25"
                  cy="542.75"
                  r="33"
                  style="fill: url(#radial-gradient-2); fill-opacity: 0.5" />
                <g>
                  <circle
                    cx="730.75"
                    cy="543.25"
                    r="27.5"
                    style="fill: #fff" />
                  <circle
                    cx="730.75"
                    cy="543.25"
                    r="26"
                    style="
                      fill: none;
                      stroke: url(#linear-gradient-2);
                      stroke-width: 3px;
                    " />
                </g>
                <text
                  transform="translate(721.32 555.04)"
                  style="
                    fill: #232e4f;
                    font-family: ArialMT, Arial;
                    font-size: 34px;
                    isolation: isolate;
                  ">
                  <tspan
                    x="0"
                    y="0">
                    +
                  </tspan>
                </text>
              </g>
              <text
                transform="translate(840 628)"
                class="multiline"
                data-width="160"
                text-anchor="middle"
                style="fill: #010b1c; font-size: 22px; isolation: isolate">
                {{ data.items[4].section_title }}
              </text>
            </g>
            <g id="Bot-center">
              <rect
                id="Color-2"
                data-name="Color"
                x="393.25"
                y="496.25"
                width="268"
                height="177"
                rx="20"
                ry="20"
                style="fill: url(#linear-gradient-3)"
                @mouseover="videoMouseEnter(3)"
                @mouseleave="videoMouseLeave()"
                @click="openModal(data, 3)" />
              <g
                id="Background"
                style="mix-blend-mode: screen">
                <g style="clip-path: url(#clippath-1)">
                  <foreignObject
                    v-if="!isSafari"
                    width="3150"
                    height="1772"
                    transform="translate(357.5 485) scale(.114)">
                    <video
                      ref="video3"
                      width="3150"
                      height="1772"
                      style="object-fit: cover"
                      muted
                      loop>
                      <source
                        :src="
                          data.items[3].mp4_file_thumb
                            ? data.items[3].mp4_file_thumb.url
                            : data.items[3].mp4_file.url
                        "
                        type="video/mp4" />

                      Your browser does not support the video tag.
                    </video>
                  </foreignObject>
                </g>
              </g>
              <g
                id="Button-2"
                data-name="Button">
                <circle
                  cx="527.25"
                  cy="543.75"
                  r="47"
                  style="fill: url(#radial-gradient-3); fill-opacity: 0.5" />
                <circle
                  cx="527.25"
                  cy="543.75"
                  r="46.5"
                  style="fill: none; stroke: rgba(186, 187, 187, 0.12)" />
                <circle
                  cx="527.25"
                  cy="543.75"
                  r="33"
                  style="fill: url(#radial-gradient-4); fill-opacity: 0.5" />
                <g>
                  <circle
                    cx="527.75"
                    cy="544.25"
                    r="27.5"
                    style="fill: #fff" />
                  <circle
                    cx="527.75"
                    cy="544.25"
                    r="26"
                    style="
                      fill: none;
                      stroke: url(#linear-gradient-4);
                      stroke-width: 3px;
                    " />
                </g>
                <text
                  transform="translate(518.32 556.04)"
                  style="
                    fill: #232e4f;
                    font-family: ArialMT, Arial;
                    font-size: 34px;
                    isolation: isolate;
                  ">
                  <tspan
                    x="0"
                    y="0">
                    +
                  </tspan>
                </text>
              </g>
              <text
                transform="translate(525 623)"
                class="multiline"
                data-width="130"
                text-anchor="middle"
                style="fill: #010b1c; font-size: 22px; isolation: isolate">
                {{ data.items[3].section_title }}
              </text>
            </g>
            <g id="Bot-left">
              <path
                id="Color-3"
                data-name="Color"
                d="M150.3,516.75l-88.55,124.4c-9.43,13.24,.04,31.6,16.29,31.6H350.75c11.05,0,20-8.95,20-20v-137c0-11.05-8.95-20-20-20H191.03c-16.18,0-31.35,7.83-40.73,21Z"
                style="fill: url(#linear-gradient-5)"
                @mouseover="videoMouseEnter(2)"
                @mouseleave="videoMouseLeave()"
                @click="openModal(data, 2)" />
              <g
                id="BG-2"
                data-name="BG"
                style="mix-blend-mode: screen">
                <g style="clip-path: url(#clippath-2)">
                  <foreignObject
                    v-if="!isSafari"
                    width="1542"
                    height="1046"
                    transform="translate(60 470) scale(0.2)">
                    <video
                      ref="video2"
                      width="1542"
                      height="1046"
                      style="object-fit: cover"
                      muted
                      loop>
                      <source
                        :src="
                          data.items[2].mp4_file_thumb
                            ? data.items[2].mp4_file_thumb.url
                            : data.items[2].mp4_file.url
                        "
                        type="video/mp4" />

                      Your browser does not support the video tag.
                    </video>
                  </foreignObject>
                </g>
              </g>
              <g
                id="Button-3"
                data-name="Button">
                <circle
                  cx="314.25"
                  cy="543.75"
                  r="47"
                  style="fill: url(#radial-gradient-5); fill-opacity: 0.5" />
                <circle
                  cx="314.25"
                  cy="543.75"
                  r="46.5"
                  style="fill: none; stroke: rgba(186, 187, 187, 0.12)" />
                <circle
                  cx="314.25"
                  cy="543.75"
                  r="33"
                  style="fill: url(#radial-gradient-6); fill-opacity: 0.5" />
                <g>
                  <circle
                    cx="314.75"
                    cy="544.25"
                    r="27.5"
                    style="fill: #fff" />
                  <circle
                    cx="314.75"
                    cy="544.25"
                    r="26"
                    style="
                      fill: none;
                      stroke: url(#linear-gradient-6);
                      stroke-width: 3px;
                    " />
                </g>
                <text
                  transform="translate(305.32 556.04)"
                  style="
                    fill: #232e4f;
                    font-family: ArialMT, Arial;
                    font-size: 34px;
                    isolation: isolate;
                  ">
                  <tspan
                    x="0"
                    y="0">
                    +
                  </tspan>
                </text>
              </g>
              <text
                transform="translate(210 628)"
                class="multiline"
                data-width="160"
                text-anchor="middle"
                style="fill: #010b1c; font-size: 22px; isolation: isolate">
                {{ data.items[2].section_title }}
              </text>
            </g>
            <g id="Mid">
              <path
                id="Color-4"
                data-name="Color"
                d="M310.24,297.46c9.46-12.42,24.17-19.71,39.78-19.71h354.45c15.61,0,30.32,7.29,39.78,19.71l110.54,145.17c10.02,13.17,.64,32.12-15.91,32.12H215.62c-16.55,0-25.94-18.95-15.91-32.12l110.54-145.17Z"
                style="fill: url(#linear-gradient-7)"
                @mouseover="videoMouseEnter(1)"
                @mouseleave="videoMouseLeave()"
                @click="openModal(data, 1)" />
              <g
                id="BG-3"
                data-name="BG"
                style="mix-blend-mode: screen">
                <g style="clip-path: url(#clippath-3)">
                  <foreignObject
                    v-if="!isSafari"
                    width="2562"
                    height="1272"
                    transform="translate(195 199.87) scale(.295)">
                    <video
                      ref="video1"
                      width="2562"
                      height="1272"
                      style="object-fit: cover"
                      muted
                      loop>
                      <source
                        :src="
                          data.items[1].mp4_file_thumb
                            ? data.items[1].mp4_file_thumb.url
                            : data.items[1].mp4_file.url
                        "
                        type="video/mp4" />

                      Your browser does not support the video tag.
                    </video>
                  </foreignObject>
                </g>
              </g>
              <g
                id="Button-4"
                data-name="Button">
                <circle
                  cx="525.25"
                  cy="324.75"
                  r="47"
                  style="fill: url(#radial-gradient-7); fill-opacity: 0.5" />
                <circle
                  cx="525.25"
                  cy="324.75"
                  r="46.5"
                  style="fill: none; stroke: rgba(186, 187, 187, 0.12)" />
                <circle
                  cx="525.25"
                  cy="324.75"
                  r="33"
                  style="fill: url(#radial-gradient-8); fill-opacity: 0.5" />
                <g>
                  <circle
                    cx="525.75"
                    cy="325.25"
                    r="27.5"
                    style="fill: #fff" />
                  <circle
                    cx="525.75"
                    cy="325.25"
                    r="26"
                    style="
                      fill: none;
                      stroke: url(#linear-gradient-8);
                      stroke-width: 3px;
                    " />
                </g>
                <text
                  transform="translate(516.32 337.04)"
                  style="
                    fill: #232e4f;
                    font-family: ArialMT, Arial;
                    font-size: 34px;
                    isolation: isolate;
                  ">
                  <tspan
                    x="0"
                    y="0">
                    +
                  </tspan>
                </text>
              </g>
              <text
                transform="translate(525 399)"
                class="multiline"
                data-width="180"
                text-anchor="middle"
                style="fill: #010b1c; font-size: 22px; isolation: isolate">
                {{ data.items[1].section_title }}
              </text>
            </g>
            <g id="Top">
              <path
                id="Color-5"
                data-name="Color"
                d="M477.58,76.95c9.5-11.53,23.65-18.2,38.59-18.2h22.17c14.94,0,29.09,6.68,38.59,18.2l120.37,146.08c10.75,13.05,1.47,32.72-15.43,32.72H372.64c-16.9,0-26.18-19.67-15.43-32.72l120.37-146.08Z"
                style="fill: url(#linear-gradient-9)"
                @mouseover="videoMouseEnter(0)"
                @mouseleave="videoMouseLeave()"
                @click="openModal(data, 0)" />
              <g
                id="BG-4"
                data-name="BG"
                style="opacity: 0.3">
                <g style="clip-path: url(#clippath-4)">
                  <foreignObject
                    v-if="!isSafari"
                    width="4096"
                    height="2602"
                    transform="translate(253 -5) scale(.11)">
                    <video
                      ref="video0"
                      width="4096"
                      height="2602"
                      style="object-fit: cover"
                      muted
                      loop>
                      <source
                        :src="
                          data.items[0].mp4_file_thumb
                            ? data.items[0].mp4_file_thumb.url
                            : data.items[0].mp4_file.url
                        "
                        type="video/mp4" />

                      Your browser does not support the video tag.
                    </video>
                  </foreignObject>
                </g>
              </g>
              <g
                id="Button-5"
                data-name="Button">
                <circle
                  cx="525.25"
                  cy="110.75"
                  r="47"
                  style="fill: url(#radial-gradient-9); fill-opacity: 0.5" />
                <circle
                  cx="525.25"
                  cy="110.75"
                  r="46.5"
                  style="fill: none; stroke: rgba(186, 187, 187, 0.12)" />
                <circle
                  cx="525.25"
                  cy="110.75"
                  r="33"
                  style="fill: url(#radial-gradient-10); fill-opacity: 0.5" />
                <g>
                  <circle
                    cx="525.75"
                    cy="111.25"
                    r="27.5"
                    style="fill: #fff" />
                  <circle
                    cx="525.75"
                    cy="111.25"
                    r="26"
                    style="
                      fill: none;
                      stroke: url(#linear-gradient-10);
                      stroke-width: 3px;
                    " />
                </g>
                <text
                  transform="translate(516.32 123.04)"
                  style="
                    fill: #232e4f;
                    font-family: ArialMT, Arial;
                    font-size: 34px;
                    isolation: isolate;
                  ">
                  <tspan
                    x="0"
                    y="0">
                    +
                  </tspan>
                </text>
              </g>
              <text
                id="Decision_Engine"
                data-name="Decision Engine"
                transform="translate(525 204)"
                class="multiline"
                data-width="160"
                text-anchor="middle"
                style="fill: #010b1c; font-size: 22px; isolation: isolate">
                {{ data.items[0].section_title }}
              </text>
            </g>
          </g>
        </svg>
        <!-- <div class="video-hover">
          <div
            v-for="(item, idx) in data.items"
            :key="idx"
            class="video-container">
            <Transition name="fade">
              <video
                v-if="item.isMp4"
                v-show="currHover === idx"
                muted
                loop
                autoplay>
                <source
                  :src="item.mp4_file.url"
                  type="video/mp4" />

                Your browser does not support the video tag.
              </video>
            </Transition>
          </div>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "PyramidComponent",
    "CLASSNAME": "pyramid",
    "URL": "http://insitro.local/test/"
   }
  #ENDMETA */
import { inject, onMounted, ref } from 'vue'

defineProps(['data'])
const video0 = ref(null)
const video1 = ref(null)
const video2 = ref(null)
const video3 = ref(null)
const video4 = ref(null)
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

const handleMultiLine = () => {
  var textBoxes = document.getElementsByClassName('multiline')
  for (var i = 0; i < textBoxes.length; i++) {
    createMultiline(textBoxes[i])
  }

  function createMultiline(textElement) {
    var words = textElement.firstChild.data.split(' ')
    var width = parseFloat(textElement.getAttributeNS(null, 'data-width'))

    // Clear original text
    textElement.firstChild.data = ''

    // Create first tspan element
    var tspanElement = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'tspan'
    )

    // Create text in tspan element
    var textNode = document.createTextNode(words[0])

    // Add tspan element to DOM
    tspanElement.appendChild(textNode)

    // Add text to tspan element
    textElement.appendChild(tspanElement)

    for (var i = 1; i < words.length; i++) {
      var len = textNode.data.length

      // Add next word
      tspanElement.firstChild.data += ' ' + words[i]

      if (tspanElement.getComputedTextLength() > width) {
        // Remove added word
        tspanElement.firstChild.data = tspanElement.firstChild.data.slice(
          0,
          len
        )

        // Create new tspan element
        tspanElement = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'tspan'
        )
        tspanElement.setAttributeNS(null, 'x', 0)
        tspanElement.setAttributeNS(null, 'dy', 24)

        textNode = document.createTextNode(words[i])
        tspanElement.appendChild(textNode)
        textElement.appendChild(tspanElement)
      }
    }
  }
}

const currHover = ref(null)

const modal = inject('valueChainModal')

const openModal = (data, idx) => {
  modal.value.isPyramid = true
  modal.value.open = true
  modal.value.data = data
  modal.value.index = idx
}

const videoMouseEnter = (idx) => {
  if (isSafari) return
  currHover.value = idx
  if (idx === 0) {
    video0.value.play()
  } else if (idx === 1) {
    video1.value.play()
  } else if (idx === 2) {
    video2.value.play()
  } else if (idx === 3) {
    video3.value.play()
  } else if (idx === 4) {
    video4.value.play()
  }
}

const videoMouseLeave = () => {
  if (isSafari) return
  currHover.value = null
  video0.value.pause()
  video1.value.pause()
  video2.value.pause()
  video3.value.pause()
  video4.value.pause()
}

onMounted(() => {
  handleMultiLine()
})
</script>

<style lang="scss" scoped>
.pyramid {
  @apply py-0 lg:-my-[40px] overflow-hidden;
  .container {
    .pyramid-svg-wrapper {
      @apply relative;
      svg {
        @apply z-2 select-none;
        text,
        g[data-name='BG'],
        g#BG,
        g#Background {
          @apply pointer-events-none;
        }
        path#Color,
        path[data-name='Color'],
        rect[data-name='Color'] {
          @apply [pointer-events:all] cursor-pointer transition-all duration-[0.2s];
          &:hover ~ g[data-name='Button'] {
            @apply [rotate:90deg] [scale:1.2];
          }
        }
        g[data-name='Button'] {
          @apply pointer-events-none transition-all duration-[0.2s] [transform-box:fill-box] origin-[50%_50%];
        }
      }
    }
  }
  .video-hover {
    @apply -z-1 hidden h-[81%] w-full
    absolute top-[7.5%] -right-[62.5%]
    transition-all duration-300
    lg:block;

    .video-container {
      video {
        position: absolute;
        object-fit: cover;
        height: 100%;
        width: 100%;
      }
    }
  }
}
</style>
